// extracted by mini-css-extract-plugin
export default {"wlMsgModalOpen":"styles-module__wlMsgModalOpen___YGSh9","wlMsgModalClose":"styles-module__wlMsgModalClose___RYLFG"};